export const normalizeResponseArray = <T>(value: T[] | null | undefined | void): T[] =>
  Array.isArray(value) ? value : [];
